import React from 'react';
import { motion } from 'framer-motion';

const verticals = [
  {
    label: 'Home Services',
    desc: 'HVAC, plumbing, electrical, roofing, restoration. Emergency calls come in after hours. If nobody answers, the next company gets the job.',
    detail: 'Valtivo catches the call, captures urgency and job details, and notifies dispatch immediately.',
  },
  {
    label: 'Auto Dealerships',
    desc: 'Service departments miss a significant share of inbound calls. Each missed service appointment is measurable lost revenue.',
    detail: 'Valtivo handles intake, routes to the right department, and sends structured summaries — during and after business hours.',
  },
  {
    label: 'Real Estate Teams',
    desc: 'Buyer and seller inquiries come in at all hours. A slow or missed response often means losing the lead entirely.',
    detail: 'Valtivo qualifies the inquiry, captures property interest, and routes to the right agent with full context.',
  },
];

const WhoItsFor = () => (
  <section className="py-20 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>Who It's For</p>
        <h2 className="text-3xl md:text-4xl font-bold" style={{ color: '#f1f1f1' }}>
          Built for businesses where unanswered<br className="hidden md:block" /> calls cost real money.
        </h2>
      </motion.div>
      <div className="grid md:grid-cols-3 gap-6">
        {verticals.map((v, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="p-7 rounded-2xl border" style={{ background: '#111', borderColor: '#1f1f1f' }}>
            <h3 className="text-lg font-bold mb-3" style={{ color: '#f1f1f1' }}>{v.label}</h3>
            <p className="text-sm leading-relaxed mb-4" style={{ color: '#666' }}>{v.desc}</p>
            <p className="text-sm leading-relaxed" style={{ color: '#4ade80' }}>{v.detail}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WhoItsFor;